export const DARK_MAP_THEME_PIXXEL =
  'neelduttapixxel/cl6ezkerc001h14nkwct1m0jo';
export const LIGHT_MAP_THEME_PIXXEL =
  'neelduttapixxel/cl5tm7r0w000i14pdu92imjpi';
export const SATELLITE_MAP_MAPBOX = 'mapbox/satellite-v8';

export const GEOSJON_COLOR_DEFAULT = '#3e63dd';
